import { Skeleton } from '@/components/ui/app-skeleton';

// ---------------------------------------------------------------------------
// Constants
// ---------------------------------------------------------------------------

const SKELETON_CARD_KEYS: readonly string[] = ['sk-thesis-0', 'sk-thesis-1', 'sk-thesis-2'];

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function DebateSkeleton(): React.ReactNode {
  return (
    <div className="flex flex-col gap-4">
      {/* Category filter skeleton */}
      <div className="flex items-center gap-2">
        <Skeleton className="h-7 w-12 rounded-full" />
        <Skeleton className="h-7 w-16 rounded-full" />
        <Skeleton className="h-7 w-16 rounded-full" />
        <Skeleton className="h-7 w-14 rounded-full" />
      </div>

      {/* Sort toggle skeleton */}
      <div className="flex items-center gap-1">
        <Skeleton className="h-7 w-16 rounded-full" />
        <Skeleton className="h-7 w-12 rounded-full" />
      </div>

      {/* Thesis card skeletons */}
      {SKELETON_CARD_KEYS.map((key) => (
        <div
          key={key}
          className="flex flex-col gap-3 rounded-card border border-border-primary p-4"
        >
          <div className="flex items-center gap-2">
            <Skeleton className="size-8 rounded-full" />
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-16" />
          </div>
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
          <div className="flex items-center gap-4">
            <Skeleton className="h-8 w-16" />
            <Skeleton className="h-8 w-16" />
            <Skeleton className="h-8 w-16" />
          </div>
        </div>
      ))}
    </div>
  );
}
